export default __webpack_public_path__ + "static/media/Group 8-7.14e24515.svg";